import { fetchAllResults } from '../fetchAllResults'

// Считает заблокированные средства за заказы.
// Заблокированные = заказ выполнен но деньги еще не сняты.
// Возможность исключения финанса по определенному заказу добавлена для расчетов доплат "на месте"
export const calculateBuyerBlockedFunds = async excludeOrderId => {
  let lockedFunds = 0

  // Запрос всех неоплаченных финансов
  const finances = await fetchAllResults('/finance/finances/', { status: 'Expected,Expired' })

  let filteredFinances = finances.results

  if (typeof excludeOrderId === 'number') {
    filteredFinances = filteredFinances.filter(item => item.order !== excludeOrderId)
  }

  // Из каждого финанса берем сумму оплаты за заказ, и прибавляем к долгу.
  for (let finance of filteredFinances) {
    lockedFunds += finance.total_product_price
  }

  return lockedFunds
}
